import script from "./BaseDivider.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseDivider.vue?vue&type=script&setup=true&lang=ts"

import "./BaseDivider.vue?vue&type=style&index=0&id=5cfaa986&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cfaa986"]])

export default __exports__